import { logger } from '../../../utils/logger';
import {
  endSessionViaSdk,
  joinAndEndSessionViaSdk,
  getForceLogoutConfig,
} from './force-logout-sdk.util';
import { forceLogoutViaApi } from './force-logout-api.util';

/**
 * Force end any existing session (used to clean up conflicting/stale sessions)
 */
export async function forceEndAllSessions(): Promise<void> {
  logger.debug('[CXone SDK] Force ending all existing sessions...');

  const config = getForceLogoutConfig();
  logger.debug('[CXone SDK] Force logout config:', {
    hasBaseUrl: !!config.baseUrl,
    baseUrl: config.baseUrl,
    hasAuthToken: !!config.authToken,
    hasAgentId: !!config.agentId,
    agentId: config.agentId,
    hasStoredUserInfo: !!config.agentId,
  });

  if (await endSessionViaSdk()) {
    return;
  }

  if (await joinAndEndSessionViaSdk()) {
    return;
  }

  const { baseUrl, authToken, agentId } = config;
  if (!baseUrl || !authToken || !agentId) {
    logger.warn('[CXone SDK] Missing config for direct API call - cannot force logout via API');
    await new Promise((resolve) => setTimeout(resolve, 1000));
    logger.debug('[CXone SDK] Force logout attempt completed');
    return;
  }

  try {
    logger.debug('[CXone SDK] Strategy 3: Direct API call to force logout...');
    await forceLogoutViaApi(baseUrl, authToken, agentId);
  } catch (apiError) {
    logger.warn('[CXone SDK] Direct API force logout failed:', apiError);
  }

  await new Promise((resolve) => setTimeout(resolve, 1000));
  logger.debug('[CXone SDK] Force logout attempt completed');
}
